export const ROWS_COUNT = 3;
export const PAGES_COUNT = 2;
